import { loadCSVList } from "./csvLoader";
export const loadAllergies = () =>
  loadCSVList("/data/clean/allergies.csv", { unique: true, sort: true, normalize: true });